export const StatutFactureDTO = {
  EnCoursDAnalyse: 'EnCoursDAnalyse',
  AttentePiecesReglement: 'AttentePiecesReglement',
  Transmis: 'Transmis',
  Paye: 'Paye',
  Rejete: 'Rejete',
  EnAttenteDeFacturation: 'EnAttenteDeFacturation',
  EnCoursDePaiement: 'EnCoursDePaiement',
  PayeSurAcompte: 'PayeSurAcompte',
} as const

export type StatutFactureDTO = keyof typeof StatutFactureDTO

export const StatutFactureLibelle: { [key in StatutFactureDTO]: string } = {
  EnCoursDAnalyse: 'En cours d\'analyse',
  AttentePiecesReglement: 'Attente pièces réglement',
  Transmis: 'Transmis',
  Paye: 'Payé',
  Rejete: "Rejeté",
  EnAttenteDeFacturation: "En attente de facturation",
  EnCoursDePaiement: "En cours de paiement",
  PayeSurAcompte: 'Payé sur acompte',
}

export const StatutFactureBadgeType = {
  EnCoursDAnalyse: 'pending',
  AttentePiecesReglement: 'pending',
  Transmis: 'success',
  Paye: 'success',
  Rejete: 'error',
  EnAttenteDeFacturation: 'info',
  EnCoursDePaiement: 'pending',
  PayeSurAcompte: 'success',
} as const
